// CheckBox.js
import { Checkbox, FormControlLabel } from "@mui/material";
import React, { useEffect, useState } from "react";

function CheckBox(props) {
  const {
    label,
    handleChange,
    value,
    checkboxstatus,
    name,
    disab,
    id,
    view,
    onCheckboxChange,
  } = props;
  const [isChecked, setIsChecked] = useState(false);
  // console.log(props.value);
  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  // console.log("checked box");

    handleChange(event);
    if (onCheckboxChange) {
      onCheckboxChange(event.target.checked);
    }
  };
  useEffect(() => {
    if (props.wellnessTips) {
      props.wellnessTips === 1
        ? setIsChecked(true)
        : setIsChecked(false);
      checkboxstatus();
    }
  }, [props.wellnessTips]);

  return (
    <FormControlLabel
      style={{
        flexDirection: "row-reverse",
        justifyContent: "start",
        marginInline: "0",
      }}
      label={<label className="label">{label}</label>}
      control={
        <Checkbox
          name={name}
          onChange={handleCheckboxChange}
          checked={isChecked}
          disabled={disab||view}
          id={id}
          sx={{
            color: "rgba(0, 0, 0, 0.6)",
            "&.Mui-checked": {
              color: "#6842d9",
            },
          }}
        />
      }
    />
  );
}

export default React.memo(CheckBox);
